import { environment } from './environment/environment';

export const isProdMode = environment.production;
